import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Service } from '@src/api/tenant/auth/tenantAuthStatusApiClient';

type CompanyUser = {
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  birthday: string;
  email: string;
  new_password?: string;
  new_password_confirmation?: string;
  avatar_url: string;
  display_name: string;
  affiliation: string;
  position: string;
  introduction: string;
  industry_visible: boolean;
  two_factor_enabled: boolean;
  email_notification_enabled: boolean;
};
type ProfileUpdateRequest = {
  company_user: Omit<CompanyUser, 'email'>;
};
type ProfilePreValidateRequest = {
  company_user: CompanyUser;
};
type ProfileUpdateResponse = unknown;
export type ProfileUpdateErrorResponse = {
  company_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    birthday: string[];
    email: string[];
    avatar_url: string[];
    new_password?: string[];
    new_password_confirmation?: string[];
    display_name: string[];
    affiliation: string[];
    position: string[];
    introduction: string[];
    industry_visible: string[];
    two_factor_enabled: string[];
    email_notification_enabled: string[];
  };
};
type UploadAvatarResponse = {
  url: string;
};
type UploadAvatarErrorResponse = {
  file: string[];
};
type VerifyEmailRequest = {
  code: string;
  password: string;
};
type VerifyEmailResponse = unknown;
export type VerifyEmailErrorResponse = {
  code: string[];
  password: string[];
  messages: string[];
};
type ProfileCompany = {
  name: string;
  industry_text: string;
};
type ProfileTenant = {
  service: Service;
};
type ProfileShowResponse = {
  user: CompanyUser & {
    logged_in_at: string | null;
  };
  company: ProfileCompany;
  tenant: ProfileTenant;
};

export const companyProfileApiClient = {
  show: async (): Promise<ApiResult<ProfileShowResponse, unknown>> => {
    return await axiosClient.get('/company/profile');
  },
  update: async (
    params: ProfileUpdateRequest,
  ): Promise<ApiResult<ProfileUpdateResponse, ProfileUpdateErrorResponse>> => {
    return await axiosClient.put('/company/profile', params);
  },
  uploadAvatar: async (
    file: File,
  ): Promise<ApiResult<UploadAvatarResponse, UploadAvatarErrorResponse>> => {
    const form = new FormData();
    form.append('file', file);
    return await axiosClient.post('/company/profile/avatar', form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  preValidate: async (
    params: ProfilePreValidateRequest,
  ): Promise<ApiResult<ProfileUpdateResponse, ProfileUpdateErrorResponse>> => {
    return await axiosClient.post('/company/profile/pre-validate', params);
  },
  verifyEmail: async (
    params: VerifyEmailRequest,
  ): Promise<ApiResult<VerifyEmailResponse, VerifyEmailErrorResponse>> => {
    return await axiosClient.post('/company/profile/email/verify', params);
  },
};
